import { Vector3D } from "@wufe/particles";
export var QuadrantLocation;
(function (QuadrantLocation) {
    QuadrantLocation["LEFT_TOP_FRONT"] = "leftTopFront";
    QuadrantLocation["RIGHT_TOP_FRONT"] = "rightTopFront";
    QuadrantLocation["LEFT_BOTTOM_FRONT"] = "leftBottomFront";
    QuadrantLocation["RIGHT_BOTTOM_FRONT"] = "rightBottomFront";
    QuadrantLocation["LEFT_TOP_BACK"] = "leftTopBack";
    QuadrantLocation["RIGHT_TOP_BACK"] = "rightTopBack";
    QuadrantLocation["LEFT_BOTTOM_BACK"] = "leftBottomBack";
    QuadrantLocation["RIGHT_BOTTOM_BACK"] = "rightBottomBack";
})(QuadrantLocation || (QuadrantLocation = {}));
export class Box {
    constructor(position, dimensions) {
        this.position = position;
        this.dimensions = dimensions;
    }
    contains(particle) {
        return !(this.position.x - this.dimensions.x >= particle.coords.x ||
            this.position.x + this.dimensions.x < particle.coords.x ||
            this.position.y - this.dimensions.y >= particle.coords.y ||
            this.position.y + this.dimensions.y < particle.coords.y ||
            this.position.z - this.dimensions.z >= particle.coords.z ||
            this.position.z + this.dimensions.z < particle.coords.z);
    }
    intersects(boundary) {
        return !(this.position.x - this.dimensions.x > boundary.position.x + boundary.dimensions.x ||
            this.position.x + this.dimensions.x < boundary.position.x - boundary.dimensions.x ||
            this.position.y - this.dimensions.y > boundary.position.y + boundary.dimensions.y ||
            this.position.y + this.dimensions.y < boundary.position.y - boundary.dimensions.y ||
            this.position.z - this.dimensions.z > boundary.position.z + boundary.dimensions.z ||
            this.position.z + this.dimensions.z < boundary.position.z - boundary.dimensions.z);
    }
}
export class QuadTree {
    constructor(boundary, _capacity = 4) {
        this.boundary = boundary;
        this._capacity = _capacity;
        this._particles = [];
        this._subdivided = false;
        this._quadrants = {};
    }
    insert(particle) {
        if (!this.boundary.contains(particle))
            return false;
        if (this._particles.length < this._capacity) {
            this._particles.push(particle);
            return true;
        }
        else {
            if (!this._subdivided)
                this._subdivide();
            for (const quadrant of Object.values(this._quadrants)) {
                if (quadrant.insert(particle))
                    return true;
            }
        }
    }
    query(boundary, foundParticles = []) {
        if (!this.boundary.intersects(boundary))
            return foundParticles;
        for (const particle of this._particles)
            foundParticles.push(particle);
        if (this._subdivided)
            for (const quadrant of Object.values(this._quadrants))
                quadrant.query(boundary, foundParticles);
        return foundParticles;
    }
    getQuadrants() {
        return this._quadrants;
    }
    _subdivide() {
        const dimensions = this.boundary.dimensions.clone().div(2);
        const { x, y, z } = this.boundary.position;
        // TODO: Remove dimensions.clone for each rectangle
        const leftTopFront = new Box(new Vector3D({ x: x - dimensions.x, y: y + dimensions.y, z: z + dimensions.z }), dimensions.clone());
        const rightTopFront = new Box(new Vector3D({ x: x + dimensions.x, y: y + dimensions.y, z: z + dimensions.z }), dimensions.clone());
        const leftBottomFront = new Box(new Vector3D({ x: x - dimensions.x, y: y - dimensions.y, z: z + dimensions.z }), dimensions.clone());
        const rightBottomFront = new Box(new Vector3D({ x: x + dimensions.x, y: y - dimensions.y, z: z + dimensions.z }), dimensions.clone());
        const leftTopBack = new Box(new Vector3D({ x: x - dimensions.x, y: y + dimensions.y, z: z - dimensions.z }), dimensions.clone());
        const rightTopBack = new Box(new Vector3D({ x: x + dimensions.x, y: y + dimensions.y, z: z - dimensions.z }), dimensions.clone());
        const leftBottomBack = new Box(new Vector3D({ x: x - dimensions.x, y: y - dimensions.y, z: z - dimensions.z }), dimensions.clone());
        const rightBottomBack = new Box(new Vector3D({ x: x + dimensions.x, y: y - dimensions.y, z: z - dimensions.z }), dimensions.clone());
        this._quadrants.leftTopFront = new QuadTree(leftTopFront, this._capacity);
        this._quadrants.rightTopFront = new QuadTree(rightTopFront, this._capacity);
        this._quadrants.leftBottomFront = new QuadTree(leftBottomFront, this._capacity);
        this._quadrants.rightBottomFront = new QuadTree(rightBottomFront, this._capacity);
        this._quadrants.leftTopBack = new QuadTree(leftTopBack, this._capacity);
        this._quadrants.rightTopBack = new QuadTree(rightTopBack, this._capacity);
        this._quadrants.leftBottomBack = new QuadTree(leftBottomBack, this._capacity);
        this._quadrants.rightBottomBack = new QuadTree(rightBottomBack, this._capacity);
        this._subdivided = true;
    }
}
